import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import WelcomeParagraphs from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeParagraphs';
import { Box } from '@material-ui/core';
import BlueCard from 'Components/ComponentLibrary/Components/Uncategorized/BlueCard';
import fr from 'facet-rest';
import Image from 'Components/ComponentLibrary/Atoms/Image';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '400px',
    alignItems: 'center',
    flexDirection: 'column',
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
  },
  rootDesktop: {
    maxWidth: '600px',
  },
  content: {
    marginTop: theme.spacing(2),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(4),
  },
  subtitle: {
    fontWeight: theme.typography.fontWeightBold,
    padding: 0,
    marginBottom: theme.spacing(2),
  },
  subtitles: {
    fontWeight: theme.typography.fontWeightBold,
    padding: 0,
  },
  subtitleText: {
    textAlign: 'center',
  },
  or: {
    padding: theme.spacing(2, 0),
  },
});

const Index = ({
  classes,
  setCollection,
}) => {
  const {
    resource,
  } = useMetaLayoutContext();

  const isMobile = useMobileLayout();

  let subtitles = null;
  if (resource.attr('subtitle')) {
    subtitles = Array.isArray(resource.attr('subtitle')) ? (
      <WelcomeParagraphs
        className={classes.subtitles}
        paragraphs={resource.attr('subtitle').map(text => ({ text }))}
        classes={{ text: classes.subtitleText }}
        variant="h6"
      />
    ) : (
      <Subtitle className={classes.subtitle} text={resource.attr('subtitle')} test={'wizard-step-subtitle'} />
    );
  }

  const uploadRelationship = resource.relationship(fr.relationships.upload.name);
  const selectDocumentRelationship = resource.relationship(fr.relationships.selectDocument.name);

  return (
    <div className={classNames(classes.root, {
      [classes.rootDesktop]: !isMobile,
    })}
    >
      {resource.attr('title')
        ? <Title className={classes.title} text={resource.attr('title')} test={'wizard-step-title'} /> : null}
      {subtitles}
      <Box className={classes.content}>
        {
          uploadRelationship ? (
            <BlueCard
              label={uploadRelationship.meta('prompt')}
              onClick={async () => { const newItemCollection = await uploadRelationship.link('related').get(); setCollection(newItemCollection); }}
              media={<Image boxSize="md" src={uploadRelationship.meta('icon')} alt={uploadRelationship.meta('prompt')} />}
            />
          ) : null
        }
        {
          uploadRelationship && selectDocumentRelationship ? (
            <Subtitle className={classes.or} text="or" />
          ) : null
        }
        {
          selectDocumentRelationship ? (
            <BlueCard
              label={selectDocumentRelationship.meta('prompt')}
              onClick={async () => { const newItemCollection = await selectDocumentRelationship.link('related').get(); setCollection(newItemCollection); }}
              media={<Image boxSize="md" src={selectDocumentRelationship.meta('icon')} alt={selectDocumentRelationship.meta('prompt')} />}
            />
          ) : null
        }
      </Box>
    </div>
  );
};

Index.propTypes = {
  classes: PropTypes.object.isRequired,
  setCollection: PropTypes.func.isRequired,
};

export default withStyles(styles)(Index);
